<template>
  <div
    class="form-group"
    :class="{ 'has-error': errors.has(validationName), 'form-group-active': active }"
  >
    <label class="control-label" v-if="label" v-html="label" />
    <input
      ref="input"
      :class="['form-control', size]"
      :autocomplete="autocompleteValue"
      :value="value"
      :type="type"
      :placeholder="placeholder"
      :name="name"
      :min="min"
      :max="max"
      :step="step"
      :readonly="readonly"
      :disabled="disabled"
      :required="required"
      :data-vv-as="label"
      @input="$emit('input', $event.target.value)"
      @blur="$emit('blur', $event.target.value), changeFocus()"
      @focus="changeFocus()"
      @keyup.enter="onEnter()"
    />
    <error-message :message="errors.first(validationName)"></error-message>
  </div>
</template>

<script>
import { EventsGlobal } from "~/events/eventsGlobal";

export default {
  inject: ["$validator"],
  name: "form-group-input",
  props: {
    type: {
      type: String,
      default: "text",
      validate: val => {
        return (
          ["text", "url", "email", "password", "search"].indexOf(val) !== -1
        );
      }
    },
    label: String,
    id: String,
    name: String,
    disabled: Boolean,
    placeholder: String,
    readonly: Boolean,
    scope: String,
    value: {
      type: [String, Number]
    },
    autoComplete: {
      type: Boolean,
      value: true
    },
    required: String,
    min: [String, Number],
    max: [String, Number],
    step: [String, Number],
    size: {
      type: String,
      default: "",
      validate: val => {
        return ["", "input-sm", "input-lg"].indexOf(val) !== -1;
      }
    }
  },
  data() {
    return {
      active: false
    };
  },
  computed: {
    autocompleteValue() {
      return this.autoComplete ? "on" : "off";
    },
    error() {
      return this.errors.has(this.name);
    },
    validationName() {
      return this.scope ? `${this.scope}.${this.name}` : this.name;
    }
  },
  methods: {
    changeFocus() {
      this.active = !this.active;
    },
    onEnter() {
      EventsGlobal.$emit("onEnter", true);
    }
  },
  watch: {
    error(value) {
      if (value)
        setTimeout(function() {
          $('[data-toggle="tooltip"]').tooltip();
        }, 1000);
    }
  },
  mounted() {
    this.$el.value = this.value;
  }
};
</script>



// WEBPACK FOOTER //
// src/components/UIComponents/Forms/FormGroupInput.vue